import { render, staticRenderFns } from "./PxyjfkEdit.vue?vue&type=template&id=cd36bc0c"
import script from "./PxyjfkEdit.vue?vue&type=script&lang=js"
export * from "./PxyjfkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports